import { db } from "../firebase-config";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { geminiGenerateJson } from "./geminiService";

/**
 * Increment this version whenever you make structural or meaningful 
 * changes to en.js to force a refresh of all cached AI translations.
 */
export const FRAMEWORK_VERSION = "2.1.0";

export const translationService = {
  /**
   * Translates or retrieves cached translation for a given block of content.
   * @param {string} langKey - e.g., 'fr', 'es'
   * @param {string} category - e.g., 'ui', 'stations', 'accreditationForm'
   * @param {Object} sourceData - The English source object
   */
  async getTranslation(langKey, category, sourceData) {
    if (!langKey || langKey === 'en') return sourceData;

    const cacheId = `${langKey}_${category}_v${FRAMEWORK_VERSION.replace(/\./g, '_')}`;
    const cacheRef = doc(db, "translations", cacheId);

    try {
      // 1. Try to get from Firestore Cache
      const cacheSnap = await getDoc(cacheRef);
      if (cacheSnap.exists()) {
        console.log(`[Translation] Cache hit for ${category} in ${langKey}`);
        return cacheSnap.data().payload;
      }

      // 2. If not found, Translate via Gemini
      console.log(`[Translation] Cache miss. AI translating ${category} into ${langKey}...`);
      
      const prompt = `
        You are an expert educational translator specializing in International Inclusion Frameworks.
        Translate the following JSON object into the native language for locale code "${langKey}".
        
        STRICT RULES:
        1. Return ONLY a raw JSON object. No preamble, no markdown code blocks, no explanation.
        2. Keep all JSON keys identical to the source.
        3. Maintain the professional, empathetic, and expert tone of the IFIP Global Excellence Framework.
        4. Do not translate technical identifiers or keys.
        
        DATA TO TRANSLATE:
        ${JSON.stringify(sourceData)}
      `;

      const translatedPayload = await geminiGenerateJson(prompt);

      // 3. Save to Firestore for future users
      await setDoc(cacheRef, {
        payload: translatedPayload,
        lang: langKey,
        category: category,
        version: FRAMEWORK_VERSION,
        translatedAt: serverTimestamp()
      });

      return translatedPayload;
    } catch (err) {
      console.error(`[Translation] Error in ${category}/${langKey}:`, err);
      return sourceData; // Fallback to English on error
    }
  }
};